export default __webpack_public_path__ + "static/media/lucio-icon.3b7e328a.webp";